export function connectionTypeFilter (station, array) {
  // If all 4 selected, display all stations (including stations with unknown
  // type details eg future stations)
  if (array.length === 4) {
    return true
  }
  // Filter stations by type
  for (const type of array) {
    if (station[type]) {
      return true
    }
  }
}

export function freePaidFilter (station, array) {
  if (array.includes('paid')) {
    if (station.hasChargingCost === true) {
      return true
    }
  }
  if (array.includes('free')) {
    if (station.hasChargingCost === false) {
      return true
    }
  }
  if (array.includes('unknown')) {
    if (station.hasChargingCost === null) {
      return true
    }
  }
}

export function chargerSpeedFilter (station, array, feature, fastLimit, mediumLimit) {
  for (const speed of array) {
    if (speed === 'fast') {
      if (station.kwRated >= fastLimit && station.installationStatus === 'Commissioned') {
        return true
      }
    }
    if (speed === 'medium' && station.installationStatus === 'Commissioned') {
      if (station.kwRated >= mediumLimit && station.kwRated < fastLimit) {
        return true
      }
    }
    // Show under construction stations of any speed
    // EVROAM sourced:
    if (station.installationStatus === speed) {
      return true
    }
    // Chargenet sourced:
    if (speed === 'Under Construction' && feature.properties.installationStatus === 'Under Construction') {
      return true
    }
    // Show future stations
    if (speed === 'Future' && feature.properties.installationStatus === 'Future') {
      return true
    }
  }
}
